import { render } from "./SendForApprovalModal.vue?vue&type=template&id=2cabaa1b&scoped=true"
import script from "./SendForApprovalModal.vue?vue&type=script&lang=js"
export * from "./SendForApprovalModal.vue?vue&type=script&lang=js"

import "./SendForApprovalModal.vue?vue&type=style&index=0&id=2cabaa1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cabaa1b"]])

export default __exports__